var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0618 22.7227L9.55078 36.9994H22.2498L18.5755 23.1738L12.0618 22.7227Z",
    fill: "#FFDB5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5442 29.3154H30.4846L30.4846 -0.000207901H35.5442C35.8506 -0.000207901 36.0977 0.245569 36.0977 0.550453V28.7648C36.0977 29.0697 35.8506 29.3154 35.5442 29.3154Z",
    fill: "#024383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 21.2547L30.4846 28.3075V1.00781L6.51562 8.06061V21.2547Z",
    fill: "#71AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 22.3037H1.45604C1.14958 22.3037 0.902545 22.0579 0.902545 21.7531L0.902545 7.64123C0.902545 7.33634 1.14958 7.09057 1.45604 7.09057H6.51562L6.51562 22.3037Z",
    fill: "#FFDB5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegaphone);
export default __webpack_public_path__ + "static/media/icon-megaphone.ee2135233c5e48b3c5b94d89332a0f1b.svg";
export { ForwardRef as ReactComponent };